/*
  ONÉRO — card de produto: bolinhas de cor + QUICK ADD por tamanho.
  Markup em snippets/onero-card-extras.liquid e snippets/onero-card-swatches.liquid.
  O envio pro carrinho é feito pelo <product-form-component> do tema; aqui só
  escolhemos qual variante vai no campo "id" antes do submit.
*/
(() => {
  if (window.__oneroCard) return;
  window.__oneroCard = true;

  const variantsOf = (qa) => {
    if (!qa._variants) {
      try {
        qa._variants = JSON.parse(qa.querySelector('[data-onero-variants]').textContent);
      } catch (e) {
        qa._variants = [];
      }
    }
    return qa._variants;
  };

  // foto de cada cor pelo texto das fotos, pra produto sem foto por variante (ex.: Envoy)
  const colorImgsOf = (qa) => {
    if (!qa._colorImgs) {
      try {
        qa._colorImgs = JSON.parse(qa.querySelector('[data-onero-color-imgs]')?.textContent || '{}');
      } catch (e) {
        qa._colorImgs = {};
      }
    }
    return qa._colorImgs;
  };

  const cardOf = (el) => el.closest('product-card');

  // QUICK ADD (08/10): o formulário vem num <template> e só entra na página onde ele aparece
  // (mouse + tela >= 750px, igual ao CSS do .onero-qa). No celular nunca entra.
  const desktopQA = window.matchMedia('(hover: hover) and (min-width: 750px)');

  const hydrate = (root, animate) => {
    root.querySelectorAll('template[data-onero-qa-tpl]').forEach((tpl) => {
      const qa = tpl.parentElement;
      tpl.replaceWith(tpl.content.cloneNode(true));
      // Entrou com o mouse já em cima: parte do estado fechado pra animação de subir rodar
      if (animate && qa) {
        qa.style.transition = 'none';
        qa.style.opacity = '0';
        qa.style.transform = 'translateY(12px)';
        void qa.offsetHeight;
        qa.style.removeProperty('transition');
        qa.style.removeProperty('opacity');
        qa.style.removeProperty('transform');
      }
    });
  };

  const hydrateAll = () => {
    if (desktopQA.matches) hydrate(document, false);
  };

  const whenIdle = (fn) => ('requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 3000 }) : setTimeout(fn, 200));
  if (document.readyState === 'complete') whenIdle(hydrateAll);
  else window.addEventListener('load', () => whenIdle(hydrateAll), { once: true });
  desktopQA.addEventListener?.('change', hydrateAll);

  const currentColor = (card, qa) => {
    if (card && card.dataset.oneroColor) return card.dataset.oneroColor;
    const ci = Number(qa.dataset.colorIndex);
    if (ci < 0) return null;
    const firstAvailable = variantsOf(qa).find((v) => v.a) || variantsOf(qa)[0];
    return firstAvailable ? firstAvailable.o[ci] : null;
  };

  const findVariant = (qa, color, size) => {
    const ci = Number(qa.dataset.colorIndex);
    const si = Number(qa.dataset.sizeIndex);
    return variantsOf(qa).find(
      (v) => (ci < 0 || color == null || v.o[ci] === color) && (si < 0 || size === '' || v.o[si] === size)
    );
  };

  // Risca os tamanhos esgotados da cor atual.
  const refresh = (card) => {
    const qa = card && card.querySelector('[data-onero-qa]');
    if (!qa) return;
    const color = currentColor(card, qa);
    qa.querySelectorAll('.onero-qa__size').forEach((btn) => {
      const v = findVariant(qa, color, btn.dataset.size);
      const ok = !!(v && v.a);
      btn.disabled = !ok;
      btn.classList.toggle('is-sold-out', !ok);
    });
  };

  document.addEventListener(
    'pointerenter',
    (e) => {
      const t = e.target;
      if (t instanceof Element && t.matches('product-card')) {
        // card que chegou depois (filtro, paginação) ainda está com o <template>
        if (desktopQA.matches) hydrate(t, true);
        refresh(t);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (e) => {
      const target = e.target instanceof Element ? e.target : null;
      if (!target) return;

      // Bolinha de cor
      const sw = target.closest('.onero-sw');
      if (sw) {
        e.preventDefault();
        e.stopPropagation();
        const card = cardOf(sw);
        if (!card) return;
        card.dataset.oneroColor = sw.dataset.color;
        card.querySelectorAll('.onero-sw').forEach((b) => b.classList.toggle('is-active', b === sw));

        const qa = card.querySelector('[data-onero-qa]');
        if (qa) {
          const v = findVariant(qa, sw.dataset.color, '');
          const withImg = variantsOf(qa).find(
            (x) => x.img && x.o[Number(qa.dataset.colorIndex)] === sw.dataset.color
          );
          const img = card.querySelector('.card-gallery slideshow-slide:not([hidden]) img, .card-gallery img');
          const url = (v && v.img) || (withImg && withImg.img) || colorImgsOf(qa)[sw.dataset.color];
          if (img && url) {
            img.removeAttribute('srcset');
            img.src = url;
          }
          refresh(card);
        }
        return;
      }

      // Tamanho do QUICK ADD
      const sizeBtn = target.closest('.onero-qa__size');
      if (sizeBtn) {
        e.stopPropagation();
        const qa = sizeBtn.closest('[data-onero-qa]');
        const card = cardOf(sizeBtn);
        const v = findVariant(qa, currentColor(card, qa), sizeBtn.dataset.size);
        const input = qa.querySelector('input[name="id"]');
        if (!v || !v.a || !input) {
          e.preventDefault();
          return;
        }
        input.value = v.id;
      }
    },
    true
  );
})();
